import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { ProjectLineItemRead } from '../../entities/project-line-item.dto';

@Injectable()
export class ProjectLineItemStore extends AbstractEntityStore<ProjectLineItemRead> {
    constructor() {
        super(PFWmsEntities.ProjectLineItem);
    }
}
